/**
 * Presentation-only Institution naming.
 *
 * Keep registry IDs, persisted Institution names and historical audit values
 * canonical. This helper is for contemporary UI surfaces only.
 */
export function institutionDisplayName(institution) {
  const name = String(institution?.name || "").trim();
  if (/ministry\s+of\s+health/i.test(name)) return "AfriMed™ • Ministry of Health Institution";
  // Technical bootstrap identifiers remain in the persisted institution
  // record, but the workspace selector is ordinary UI rather than evidence
  // metadata. Keep the selectable institution while omitting proof-run text.
  const humanName = name
    .replace(/\b3B1B\b\s*/gi, "")
    .replace(/\bmrgntec[\w-]*\b/gi, "")
    .replace(/\s{2,}/g, " ")
    .trim();
  return humanName || "Institution workspace";
}
